"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const request_1 = require("../requests/request");
class API {
    /**
     * Sign up for an contest
     * @returns {Promise<Contest>} The Promise contains either a device or an APIError if rejected
     */
    static track(events, platform) {
        let apiRequest = new request_1.BasicRequest('/analytics/track/' + platform, request_1.HTTPMethod.POST, request_1.APIVersion.v3_0, undefined, {
            events
        });
        return apiRequest.send().then((data) => {
            return void 0;
        });
    }
}
exports.API = API;



//////////////////
// WEBPACK FOOTER
// ./node_modules/bpm-client-api/lib/endpoints/analytics.js
// module id = 965
// module chunks = 0